<template>
        <div v-if="!isComplete">
            Загружается...
        </div>
        <div v-else>
        <ul class="nav nav-tabs nav-justified pb-4">
          <li class="nav-item">
            <a class="nav-link" @click.prevent="setActive('tabSettings')" :class="{ active: isActive('tabSettings') }" href="#tabSettings">Настройка маршрута</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" @click.prevent="setActive('tabRoad')" :class="{ active: isActive('tabRoad') }" href="#tabRoad">Маршрутный лист</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" @click.prevent="setActive('tabHistory')" :class="{ active: isActive('tabHistory') }" href="#tabHistory">История согласования</a>
          </li>
        </ul>
        <div class="tab-content card-content" id="routeTabContent">
          <div class="tab-pane fade" :class="{ 'active show': isActive('tabSettings') }" id="tabSettings">

              <div class="row d-flex align-items-baseline justify-content-center mt-10" v-if="!isReadonly">
                <div v-if="!currentRoute" class="col md-2">
                  <button-component  type="button" class="btn btn-primary mx-2 width-auto" v-on:click="create">Создать</button-component>
                </div>
                <div  v-if="currentRoute"  class="col-2 md-2 text-center">
                <label>Выберите шаблон</label>
                </div>
                <div v-if="currentRoute" class="col-4 md-6">
               <div class="form-group select2">
                   <Select2
                       :options="routeTemplates"
                       v-model="currentRoute.routeId"
                       v-on:select="routeTemplateChanged()"
                   />
               </div>
                </div>

              </div>
            <div>
              <div v-if="currentRoute && currentRoute.stepsDto.length > 0" class="col md-2 text-right d-flex justify-content-end">
                <button-component type="button" class="btn btn-primary mx-2" v-on:click="clear">Очистить</button-component>
              </div>
              <EditRouteComponent v-if="currentRoute" v-bind:steps="currentRoute.stepsDto"
                                  v-bind:needSave="needSaveInternal" :isReadonly="isReadonly"
                                  v-bind:routeId="currentRoute.id"
                                  v-on:saveSteps="onSaveSteps($event)"/>
            </div>

            </div>            

          <div class="tab-pane fade" :class="{ 'active show': isActive('tabRoad') }" id="tabRoad">
                <PassingRouteComponent v-if="currentRoute" :journalId="journalId" :isReadonly="isReadonly" v-on:reload="onReload()"/>
          </div>
          <div class="tab-pane fade" :class="{ 'active show': isActive('tabHistory') }" id="tabHistory">
              <HistoryRouteComponent :journalId="journalId"/> 
          </div>
        </div>
        <div class="card-footer mt-5">
            <div class="d-flex align-items-center float-right">
              <button-component class="btn btn-primary mx-2" v-on:click="save" v-if="!isReadonly">Сохранить</button-component>
              <button-component kind="secondary" type="button" class="btn btn-default" v-on:click="close">Закрыть</button-component>
            </div>
        </div>           
 </div>
</template>

<script>
import API from '../api/route'
import EditRouteComponent from '../../admin/components/EditRouteComponent.vue';
import PassingRouteComponent from '../components/PassingRouteComponent.vue';
import HistoryRouteComponent from '../components/HistoryRouteComponent.vue';
import ButtonComponent from "@/common/ui/ButtonComponent";
import APIjournal from '../api/journal';
import Constants from '../../../common/constants';

export default {
  name: "JournalTabRoute",
  components: {
      ButtonComponent,
    EditRouteComponent,
    PassingRouteComponent,
    HistoryRouteComponent 
  },
  props: {
    journalId: Number,
    //needSave: {
    //    type: Number,
    //    default: 0
    //},
    isReadonly: {
      type: Boolean,
      default: false
    }

  },
  emits: ['saveJournalRoute', 'reload'], 
  data: () => ({
      activeItem: 'tabSettings',
      currentRoute: null,
      routeTemplates: [],
      needSaveInternal: 0,
      isComplete: false,
  }),
  created() {
      API.loadRoutes().then((function(response){
        this.routeTemplates =  $.map( response.data.items, function (obj) {
            obj.text = obj.name;
            return obj;
          });    
      }).bind(this));    
    this.loadCurrentRoute();  
  },
  watch: {
            journalId: function (/*newValue, oldValue*/) {
                this.loadCurrentRoute();
            },
            //needSave: function(newVal, oldVal) {
            //  if (newVal != oldVal){
            //    console.log('needSave tabroute');
            //    //const i = Object.assign([], this.currentRoute);
            //    this.needSaveInternal = newVal;
            //    //this.$emit('saveJournalRoute', i);
            //  }
            //}            
        },
  methods: {
    onReload() {
      console.log('reload! journalTabRoute');
      this.$emit('reload');
    },
    isActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      this.activeItem = menuItem
    },    
    loadCurrentRoute() {
      console.log('-----load page journaltabroute');
        if(this.journalId > 0) {
          var self = this;
          self.isComplete = false;
          API.current({journalId : this.journalId}).then(function (response) {
            self.currentRoute = response.data;
            self.isComplete = true;
          });      
      }      
    },
    create() {
      this.currentRoute = {id: 0, steps: [],stepsDto: [], journalId: this.journalId, isActive: true, isComplete: false}
      //var step = {id: 0, orderNum: 1, journalRouteId: 0, isComplete: false, isActive: true, signers: []}
      //this.currentRoute.steps.push(step);
    },
    clear() {
      var step = {id: 0, orderNum: 1, journalRouteId: this.currentRoute.id, isComplete: false, isActive: true, signers: [], signersDto: []}
      this.currentRoute.stepsDto = [step];
      this.currentRoute.routeId = null;
    },
    routeTemplateChanged() {
      API.find(this.currentRoute.routeId).then(response=>{
        var stepsInternal = [];
        response.data.steps.forEach(st => {
          const stInternal = Object.assign({}, st);
          stInternal.id = 0;
          stInternal.journalRouteId = this.currentRoute.id;
          stInternal.signers=[];
          stInternal.signersDto=[];
          st.signers.forEach(s=>{
            const sInternal = Object.assign({}, s);
            sInternal.id = 0;
            sInternal.journalRouteStepId = 0;
            stInternal.signers.push(sInternal);
            stInternal.signersDto.push(sInternal);
          });
          stepsInternal.push(stInternal);
        });
        this.currentRoute.stepsDto = stepsInternal;
        console.log(this.currentRoute, '--- loaded from template');
      })
    },
    save(){
      this.needSaveInternal++;
    },
    onSaveSteps(steps) {
      console.log(steps, '---------- onSaveSteps');

      var isValid = true;
      this.currentRoute.stepsDto.forEach(function(el){
        el.signersDto.forEach(function(s){
          if(!(s.organizationId) || !(s.roleId))
            isValid = false;
        });
      });
      if (!isValid) {
        Constants.alert.fire('Ошибка', 'Необходимо корректно заполнить Организации и Роли для всех этапов', 'error');
        return;
      }

      this.currentRoute.steps = steps;
      const journalRoute = Object.assign({}, this.currentRoute);
      //this.$emit('saveJournalRoute', i);
        APIjournal.saveRoute(journalRoute).then((response) => {
          if (journalRoute.id === 0 && response.data.success) {
            Constants.alert.fire('Успешно', 'Маршрутный лист успешно сохранен, теперь доступно формирование ИМАР', 'success');
          } else {
            if (response.data.success)
              Constants.alert.fire('Успешно', 'Маршрутный лист успешно сохранен', 'success');
            else
              Constants.alert.fire('Ошибка', response.data.message, 'error');
          }
        })      
    },
    close() {
      this.$router.push({name: 'Journal', query: { page1: this.$route.query.page1 }});
    }
  }
};
</script>

<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.nav-tabs{
  .nav-item{
    .nav-link{
      padding-bottom: 16px;
      color: $black;
      font-weight: bold;
      border: none;
      border-bottom: 1px solid $blue-light;;
      &.active{
        color: $blue-light;
      }
    }
  }
}
.select2::v-deep {
    .select2-container {
        width: 100% !important;
        max-width: 100% !important;
    }

    .select2-container--default .select2-selection--single {
        height: calc(2.25rem + 2px) !important;
    }

    .select2-container--default .select2-selection--single .select2-selection__arrow {
        top: 7px !important;
    }
}
.nav-tabs {
    justify-content: center;
    border: none;

    .nav-item {
        margin-top: 12px;
        max-width: 240px;
        width: 100%;

        &:not(:last-child) {
            margin-right: 16px;
        }

        .nav-link {
            padding: 14.5px 20px;
            text-align: center;
            font-family: "Source Sans Pro", sans-serif;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 120%;
            color: $gray-dark;
            border: 1px solid $gray-light1;
            box-sizing: border-box;
            border-radius: 6px;

            &.active {
                color: $blue-light;
                border: 1px solid $blue-light;
            }
        }
    }
}
.form-check-input{
    position: static !important;
}
.card-footer{
    padding: 0;
    background-color: transparent;
    border: none;
}
</style>
